export type Role = "owner" | "admin" | "staff" | "vendor" | "viewer";

export interface Membership { org_id: string; role: Role; organizations: { name: string } }

export interface Provider {
  id: string; org_id: string; user_id: string | null; first_name: string; last_name: string; email: string;
  phone: string | null; npi: string | null; caqh_id: string | null; practice_states: string[];
  status: string; intake_link_sent_at: string | null; notes: string | null;
  sms_opt_in?: boolean; sms_consent_at?: string | null; sms_opt_out_at?: string | null;
}

export interface Payer {
  id: string; slug: string; name: string; states: string[]; payer_type: string; priority_tier: number;
  credentialing_entity: string | null; how_to_apply: string | null; caqh_used: string | null;
  network_status: string | null; provider_relations_contact: string | null; research: any;
}

export interface Application {
  id: string; org_id: string; provider_id: string; payer_id: string; entity_id: string | null;
  status: string; submitted_on: string | null; payer_reference_no: string | null; payer_contact_email: string | null;
  next_follow_up_on: string | null; approved_on: string | null; effective_on: string | null;
  backdate_requested: boolean; backdate_requested_to: string | null; backdate_outcome: string | null;
  recred_due_on: string | null; blocked_reason: string | null; last_event_at: string; notes: string | null;
  assignee?: string | null;
  providers?: { first_name: string; last_name: string; npi: string | null; caqh_id: string | null };
  payers?: { name: string; slug: string };
  legal_entities?: { legal_name: string; group_npi: string | null; tin_last4: string | null } | null;
}

export const APP_STATUSES = [
  "not_started", "collecting_docs", "ready_to_submit", "submitted", "in_review", "info_requested",
  "approved", "contracted", "effective", "denied", "withdrawn", "blocked",
] as const;

export const CREDENTIAL_KINDS = [
  ["ny_lba", "NY license (LBA)"], ["nj_lba", "NJ license (LBA)"], ["bacb_certification", "BACB certification"],
  ["malpractice", "Malpractice insurance"], ["caqh_attestation", "CAQH attestation"],
  ["ny_medicaid_id", "NY Medicaid ID"], ["nj_medicaid_id", "NJ Medicaid ID"],
  ["background_check", "Background check"], ["cpr", "CPR"], ["other_state_license", "Other state license"], ["other", "Other"],
] as const;

export const DOC_TYPES = [
  ["license", "License"], ["bacb_certificate", "BACB certificate"], ["malpractice", "Malpractice policy"],
  ["resume", "Resume / CV"], ["diploma", "Diploma"], ["cpr", "CPR card"], ["background_check", "Background check"],
  ["caqh_summary", "CAQH summary"], ["other", "Other"],
] as const;
